'use client';

import { CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useTranslations } from 'next-intl';

interface Props {
  hasErrors?: boolean;
}

const ExploitSafeMessage = ({ hasErrors }: Props) => {
  const t = useTranslations();

  const description = hasErrors
    ? t('exploits.premium.safe.description_with_errors')
    : t('exploits.premium.safe.description');

  return (
    <div
      className={
        hasErrors
          ? 'rounded-lg border border-yellow-500/50 bg-yellow-50 dark:bg-yellow-950/20 p-6'
          : 'rounded-lg border border-green-500/50 bg-green-50 dark:bg-green-950/20 p-6'
      }
    >
      <div className="flex items-center gap-4">
        {hasErrors ? (
          <ExclamationTriangleIcon className="h-12 w-12 shrink-0 text-yellow-500" />
        ) : (
          <CheckCircleIcon className="h-12 w-12 shrink-0 text-green-500" />
        )}
        <div>
          <h3 className="text-lg font-bold">
            {t(hasErrors ? 'exploits.premium.safe.title_with_errors' : 'exploits.subpages.result.safe.title')}
          </h3>
          <p className="text-sm text-zinc-600 dark:text-zinc-400">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default ExploitSafeMessage;
